var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 14.1659V15.8325C3.33398 16.2745 3.50958 16.6985 3.82214 17.011C4.1347 17.3236 4.55862 17.4992 5.00065 17.4992H15.0007C15.4427 17.4992 15.8666 17.3236 16.1792 17.011C16.4917 16.6985 16.6673 16.2745 16.6673 15.8325V14.1659M5.83398 9.16585L10.0007 13.3325L14.1673 9.16585M10.0007 3.33252V13.3325",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3f0730041d8c10fa9e2d1fbacd946de5.svg";
export { ForwardRef as ReactComponent };